import { DataGrid } from "@mui/x-data-grid";
import { Box, Card, IconButton, Skeleton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";

const TYPE_LABELS = {
  global: "Global search",
  ai: "AI search (Find a Car)",
};

const columns = [
  {
    field: "searchType",
    headerName: "Type",
    minWidth: 160,
    valueGetter: (params) =>
      TYPE_LABELS[params.row.searchType] || params.row.searchType || "Global search",
  },
  {
    flex: 1,
    field: "label",
    headerName: "Label",
    minWidth: 180,
  },
  {
    flex: 1,
    field: "searchQuery",
    headerName: "Search Query",
    minWidth: 180,
  },
  {
    field: "sortOrder",
    headerName: "Order",
    width: 90,
  },
  {
    field: "isActive",
    headerName: "Active",
    width: 100,
    valueGetter: (params) => (params.row.isActive ? "Yes" : "No"),
  },
  {
    field: "edit",
    headerName: "Edit",
    sortable: false,
    width: 70,
    headerAlign: "center",
    align: "center",
    disableClickEventBubbling: true,
    renderCell: (cell) => (
      <IconButton
        variant="outlined"
        component={Link}
        to={`/suggested-search/edit/${cell.id}`}
      >
        <EditIcon />
      </IconButton>
    ),
  },
  {
    field: "delete",
    headerName: "Delete",
    sortable: false,
    width: 90,
    headerAlign: "center",
    align: "center",
    disableClickEventBubbling: true,
    renderCell: () => (
      <IconButton variant="contained">
        <DeleteIcon />
      </IconButton>
    ),
  },
];

export default function SuggestedSearchListing({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  onSelectDelete,
}) {
  function handleCellClick(params) {
    if (params.field === "delete") {
      onSelectDelete(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          rows={data?.suggestedSearches || []}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
          getRowId={(row) => row.id}
        />
      </Box>
    </Card>
  );
}
